import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import { makeStyles } from '@material-ui/core'
import Trovitylogo from 'src/assets/Dashboard/Trovitylogo.svg'

const MobileVerification = () => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [response, setResponse] = useState('')
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true)

  const classes = useStyles()
  const history = useHistory()

  const formatPhoneNumber = () => {
    return null
  }

  const handlePhoneNumberChange = (event) => {
    const value = event?.target?.value
    const formattedValue = formatPhoneNumber(value)

    if (formattedValue) {
      setPhoneNumber(formattedValue)
      setIsValidPhoneNumber(true)
    } else {
      setPhoneNumber(value)
      setIsValidPhoneNumber(false)
    }
  }

  const handleSendOtp = () => {
    // make API call to send OTP
    const data = { phone_number: phoneNumber }
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer your_token_here',
      },
    }
    axios
      ?.post('url', data, config)
      ?.then((res) => {
        if (res?.data?.success) {
          setResponse(
            <span className={classes.otpSuccess}>
              OTP has been sent successfully
            </span>
          )
          history.push('/otp-verification')
        } else {
          setResponse(
            <span className={classes.otpFailed}>
              OTP send failed. Please try again
            </span>
          )
        }
      })
      .catch(() => {
        setResponse(
          <span className={classes.otpError}>
            An error occurred while sending OTP. Please try again later
          </span>
        )
      })
  }
  return (
    <div>
      <div className={classes.trovityLogo}>
        <img src={Trovitylogo}></img>
      </div>
      <div className={classes.container}>
        <div className={classes.containerContent}>
          <p className={classes.verifyPhoneNumberText}>
            Verify your phone number ?
          </p>

          <div className={classes.inputContainer}>
            <input
              id='phonenumberonchange'
              className={classes.inpuTextBox}
              type='tel'
              defaultValue={'+91'}
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              placeholder='987-654-3211'
              required
            />
          </div>
          {!isValidPhoneNumber && (
            <span className={classes.validPhoneNumberStyles}>
              Please enter a valid phone number
            </span>
          )}
          <button className={classes.buttonOtp} onClick={handleSendOtp}>
            <p className={classes.sendOtpText}>Send OTP</p>
          </button>

          <p className={classes.mobileNumberVerificationText}>
            An OTP will be sent to your mobile number for verification
          </p>
          <p>{response}</p>
        </div>
      </div>
    </div>
  )
}

export default MobileVerification

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '202px',
  },
  buttonOtp: {
    boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    background: '#B92250',
  },
  mobileNumberVerificationText: {
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    textAlign: 'center',
    color: 'black',
  },
  otpFailed: {
    color: 'red',
    fontFamily: 'roboto',
  },
  otpSuccess: {
    color: 'green',
  },
  otpError: {
    color: 'red',
    fontFamily: 'roboto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  trovityLogo: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '55px',
    paddingLeft: '66px',
    display: 'flex',
  },
  inpuTextBox: {
    boxSizing: 'border-box',
    border: '1px solid #BCBCBC',
    borderRadius: '20px',
    background: '#FFFFFF',
    padding: '10px',
    maxWidth: '100%',
  },
  verifyPhoneNumberText: {
    fontFamily: 'roboto',
    fontSize: '18px',
    lineHeight: '16.41px',
    color: '#000000',
  },
  // form: {
  //   inset: '0px',
  //   position: 'absolute',
  //   width: '100%',
  //   height: '100%',
  // },
  sendOtpText: {
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '2px',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'center',
  },
  containerContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: '22px',
    padding: '2px',
  },
  // phonetext: {
  //   fontFamily: 'roboto',
  //   fontStyle: 'normal',
  //   fontWeight: 'bold',
  //   fontSize: '18px',
  //   lineHeight: '21px',
  //   textAlign: 'center',
  //   color: '#000000',
  // },
  textTitle: {
    color: 'black',
    alignItems: 'ceneter',
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: 'bold',
  },
  validPhoneNumberStyles: {
    color: 'red',
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    textAlign: 'center',
  },
})
